import { RouterProvider } from '@tanstack/react-router'
import type { QueryClient } from '@tanstack/react-query'
import type { AuthStore, StaffSession } from '@pa/staff'
import { ImpersonationProvider, type ImpersonationController } from '@/features/impersonation'
import { Providers } from './providers'
import type { createAppRouter } from './router'

export function App({
  queryClient,
  router,
  auth,
  session,
  impersonation,
}: {
  queryClient: QueryClient
  router: ReturnType<typeof createAppRouter>
  auth: AuthStore
  session: StaffSession
  impersonation: ImpersonationController
}) {
  return (
    <Providers queryClient={queryClient} auth={auth} session={session}>
      <ImpersonationProvider controller={impersonation}>
        <RouterProvider router={router} />
      </ImpersonationProvider>
    </Providers>
  )
}
